// export const categoryColors = {
//   Root: "#4B6C65",
//   // "Root": "#ff6b6b",
//   "Core Concept": "#3A506B",
//   Model: "#50435A",
//   Tool: "#6C5B3F",
//   Algorithm: "#4B6C65",
//   Challenge: "#8B4C4C",
//   Methodology: "#4C6B8B",
//   Concept: "#6A556C",
//   "Use Case": "#6B8B4C",
//   Field: "#6A4D4D",
// };

export const categoryColors = {
  Root: "#4B6C65",
  // "Root": "#ff6b6b",
  "Foundational Concepts": "#3A506B",
  "Models & Architectures": "#50435A",
  "Tools & Metrics": "#6C5B3F",
  "Algorithm & Techniques": "#4B6C65",
  "Model Challenges": "#8B4C4C",
  // Methodology: "#4C6B8B",
  // Concept: "#6A556C",
  "Use Cases": "#6B8B4C",
  // Field: "#6A4D4D",
};


// export const categoryColors = {
//   "Core Concept": "#3A506B",
//   Subfield: "#4C5F4C",
//   "ML Type": "#5D4A61",
//   "ML Task": "#6A556C",
//   "ML Model": "#50435A",
//   Tool: "#6C5B3F",
//   "Related Field": "#58586F",
//   Application: "#6A4D4D",
//   Algorithm: "#4B6C65",
//   Challenge: "#8B4C4C",
//   Method: "#4C6B8B",
//   Metric: "#6B8B4C"
// };